import React from 'react'

const buttonStyle = {
  borderRadius: 0,
}

const IconButton = (props) => (
  <button
    style={buttonStyle}
    {...props}
  />
)

export default IconButton



// WEBPACK FOOTER //
// ./src/browser/components/IconButton.js